import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/segmentos-de-folios/';

/**
 * GET segmentos de folios
 *  * @param {number} idConfiguracion
 * @returns {Promise<Array<object>>}
 */
export const getSegmentosDeFolios = async (idConfiguracion) => {
  try {
    const response = await API.get(baseURI, {
      params: {
        configuracion_de_folio: idConfiguracion,
      },
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST segmento de folio
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSegmentoDeFolio = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST segmento de folio
 * @param {Array<object>} segmentos
 * @returns {Promise<boolean>}
 */
export const postSegmentosDeFolios = async (segmentos) => {
  try {
    const promises = [];
    segmentos.forEach((values) => {
      const res = API.post(baseURI, values);
      promises.push(res);
    });
    await Promise.all(promises);
    onSuccess(null, 'Segmentos agregados correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH segmento de folio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSegmentosDeFolios = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
